export default __webpack_public_path__ + "static/adding-fa3abd5d0959e0ccfbddd6254a5e30ff.png";